import React, { useEffect, useState } from 'react';

import { inject } from 'mobx-react';
import { withI18n } from 'spa/Components/Context';
import moment from 'moment';
import PropTypes from 'prop-types';

import DayPickerInput from 'react-day-picker/DayPickerInput';
import Fieldset from '@urbanmassage/component-library/lib/Fieldset/Fieldset';
import Input, { InputType } from '@urbanmassage/component-library/lib/Input/Input';
import Radio from '@urbanmassage/component-library/lib/Radio/Radio';
import Typography, { TypeVariants } from '@urbanmassage/component-library/lib/Typography/Typography';

import 'react-day-picker/lib/style.css';

const DISPLAY_DATE_FORMAT = 'DD/MM/YYYY';

const GiftCardBuyRecipientEvoucher = ({
  gifts,
  handleRecipientChange,
  recipient,
  sendDateInvalid,
  setSendDateInvalid,
}, { i18n }) => {
  // check if is browser and not server
  if (typeof window === 'undefined') {
    return null;
  }

  // eslint-disable-next-line
  const [selectedDate, setSelectedDate] = useState(sessionStorage.getItem('giftsV2') ? JSON.parse(sessionStorage.getItem('giftsV2')).recipient.sendDay : '');

  const handleDateChange = (day) => {
    const formattedDay = day ? moment(day).format(gifts.DATE_FORMAT) : '';
    const event = {
      target: {
        name: 'sendDay',
        value: formattedDay,
      },
    };
    setSelectedDate(formattedDay);
    handleRecipientChange(event);
    if (formattedDay) {
      setSendDateInvalid(false);
    }
  };

  const handleOnChange = (e) => {
    if (e.target.name === 'shippingOption') {
      if (e.target.value === 'now') {
        setSelectedDate('');
      }
    }
    handleRecipientChange(e);
  };

  useEffect(() => {
    if (!selectedDate) {
      handleDateChange('');
    }
  }, [selectedDate]);

  return (
    <div>
      <div className="gifts__recipient-form-input-wrapper">
        <Input type="email" value={recipient.email || ''} name="email" required label={i18n._x('Recipient\'s email', 'Gifts page form')} placeholder={i18n._x('Email', 'Gifts page form')} onChange={handleOnChange} />
      </div>
      <div className="gifts__recipient-form-input-wrapper">
        <Input type={InputType.text} value={recipient.name || ''} name="name" required label={i18n._x('Recipient\'s name', 'Gifts page form')} placeholder={i18n._x('To', 'Gifts page form')} onChange={handleOnChange} />
      </div>
      <div className="gifts__recipient-form-input-wrapper">
        <Input type={InputType.text} value={recipient.from || ''} name="from" required label={i18n._x('From', 'Gifts page form')} placeholder={i18n._x('Your name', 'Gifts page form')} onChange={handleOnChange} />
      </div>
      <div className="gifts__recipient-form-input-wrapper gifts__recipient-shipping">
        <Fieldset legend={i18n._x('When shall we send it?', 'Gifts page form')} onChange={handleOnChange}>
          <div className="gifts__recipient-shipping-option">
            <Radio label={i18n._x('Now', 'Gifts page form')} name="shippingOption" defaultChecked={recipient.shippingOption === 'now'} value="now" pre={false} />
          </div>
          <div className="gifts__recipient-shipping-option">
            <Radio label={i18n._x('Specific date', 'Gifts page form')} name="shippingOption" defaultChecked={recipient.shippingOption === 'later'} value="later" pre={false} />
          </div>
        </Fieldset>
      </div>
      {recipient.shippingOption === 'later' && (
        <div className={`gifts__recipient-form-input-wrapper gifts__recipient-calendar ${sendDateInvalid && 'gifts__recipient-calendar--error'}`}>
          <Typography allCaps variant={TypeVariants.legend} className="gifts__recipient-calendar-label">
            {i18n._x('Specific date', 'Gifts page form')}
          </Typography>
          <DayPickerInput
            name="sendDay"
            placeholder={i18n._x('Select date', 'Gifts page form')}
            format={DISPLAY_DATE_FORMAT}
            value={selectedDate ? moment(selectedDate).format(DISPLAY_DATE_FORMAT) : ''}
            onDayChange={handleDateChange}
            readOnly="readOnly"
            dayPickerProps={{
              locale: i18n.lc,
              months: moment.months(),
              weekdaysLong: moment.weekdays(),
              weekdaysShort: moment.weekdaysShort(),
              disabledDays: {
                before: new Date(),
              },
            }}
          />
        </div>
      )}
    </div>
  );
};

GiftCardBuyRecipientEvoucher.propTypes = {
  handleRecipientChange: PropTypes.func.isRequired,
  recipient: PropTypes.object.isRequired,
  sendDateInvalid: PropTypes.bool,
  setSendDateInvalid: PropTypes.func.isRequired,
  gifts: PropTypes.object.isRequired,
};

export default inject(({
  store: {
    gifts,
  },
}) => ({
  gifts,
}))(withI18n(GiftCardBuyRecipientEvoucher));



// WEBPACK FOOTER //
// ./spa/Pages/Gifts/GiftCardBuyRecipientEvoucher.jsx